export default {
  install (Vue, options) {
    Vue.prototype.$wx = window.wx
  }
}



// WEBPACK FOOTER //
// ./src/plugins/wechat-sdk.js